var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "material-pages-wrapper"
  }, [_c('website-header', {
    staticStyle: {
      "position": "absolute"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "master-vision"
  }, [_vm.showType == 'pc' ? _c('div', {
    ref: "phone",
    staticClass: "phone"
  }, [_c('video', {
    ref: "video",
    attrs: {
      "src": "https://sync.liveme.com/app/homevideo/website.mp4",
      "playsinline": "playsinline",
      "webkit-playsinline": "playsinline",
      "x5-playsinline": "playsinline",
      "loop": "",
      "preload": ""
    },
    domProps: {
      "muted": _vm.muted
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "volume",
    class: {
      muted: _vm.muted
    },
    on: {
      "click": _vm.toggleMuted
    }
  })]) : _vm._e(), _vm._v(" "), _vm.showType == 'mobile' ? _c('div', {
    staticClass: "phone"
  }, [_c('div', {
    staticClass: "iphone_bg"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aside"
  }, [_c('div', {
    staticClass: "slogan"
  }, [_vm._v(_vm._s(_vm.$t("indexmaterial.slogan")))]), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [[_c('p', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.$t('indexmaterial.download_appstore_tips')))]), _vm._v(" "), _c('a', {
    staticClass: "dl-link appstore",
    attrs: {
      "target": "_blank",
      "href": _vm.downloads.applestore
    },
    on: {
      "click": function click($event) {
        return _vm.tongjiAppDown('IOS');
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dl-link googleplay",
    attrs: {
      "target": "_blank",
      "href": _vm.downloads.googleplay
    },
    on: {
      "click": function click($event) {
        return _vm.tongjiAppDown('gp');
      }
    }
  }), _vm._v(" "), _vm.IPCountryCode && _vm.IPCountryCode !== 'CN' ? _c('a', {
    staticClass: "dl-link apk",
    class: _vm.getAndroidClass(),
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function click($event) {
        _vm.tongjiAppDown('Android');
        _vm.anCroDown();
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.downloads.huaweistore,
      expression: "downloads.huaweistore"
    }],
    staticClass: "dl-link huawei",
    attrs: {
      "target": "_blank",
      "href": _vm.downloads.huaweistore
    },
    on: {
      "click": function click($event) {
        return _vm.tongjiAppDown('HuaWei');
      }
    }
  })]], 2)])]), _vm._v(" "), !_vm.showDownload ? _c('div', {
    staticClass: "helpful-tips"
  }, [_vm._v("如遇下載或使用問題，請聯繫我們（"), _c('a', {
    attrs: {
      "href": "mailto:livemetw@liveme.com"
    }
  }, [_vm._v("livemetw@liveme.com")]), _vm._v("）")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "partners"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("indexmaterial.partners")))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm.newslist && _vm.newslist.length ? _c('div', {
    staticClass: "news"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("indexmaterial.news"))), _c('a', {
    staticClass: "more",
    attrs: {
      "href": _vm.getUrlLink('/list.html')
    }
  }, [_vm._v(_vm._s(_vm.$t("indexmaterial.more")))])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_vm._l(_vm.newsListOfCurrentPage, function (item, index) {
    return _c('li', {
      key: _vm.newsPage * _vm.pageSize + index
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "wrapper"
    }, [_c('img', {
      staticClass: "image",
      attrs: {
        "src": item.image || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(item.media))])]), _vm._v(" "), _c('div', {
      staticClass: "summary"
    }, [_vm._v(_vm._s(item.title))])])]);
  }), _vm._v(" "), _c('li', {
    staticClass: "empty"
  }), _vm._v(" "), _c('li', {
    staticClass: "empty"
  })], 2), _vm._v(" "), _vm.newsTotalPage > 1 ? _c('ul', {
    staticClass: "pages"
  }, _vm._l(_vm.newsTotalPage, function (index) {
    return _c('li', {
      key: index,
      class: {
        current: _vm.newsCurrentPage == index
      }
    }, [_c('a', {
      on: {
        "click": function click($event) {
          return _vm.skipNewsPage(index);
        }
      }
    }, [_vm._v(_vm._s(index))])]);
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "previous-partner"
  }, [_vm._v(_vm._s(_vm.$t("indexmaterial.prevpartner")))]), _vm._v(" "), _c('website-footer')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "central-gray-backdrop"
  }), _vm._v(" "), _c('div', {
    staticClass: "left-triangle-bubble"
  }), _vm._v(" "), _c('div', {
    staticClass: "right-circle-bubble"
  }), _vm._v(" "), _c('div', {
    staticClass: "top-circle-bubble"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-rounded-rectangle-bubble"
  }), _vm._v(" "), _c('div', {
    staticClass: "central-circle-bubble"
  }), _vm._v(" "), _c('div', {
    staticClass: "top-left-accessor"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-right-accessor"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "colour-pop"
  }), _vm._v(" "), _c('li', {
    staticClass: "huawei"
  }), _vm._v(" "), _c('li', {
    staticClass: "samsung"
  }), _vm._v(" "), _c('li', {
    staticClass: "fullscreen"
  }), _vm._v(" "), _c('li', {
    staticClass: "the-20th-century-fox"
  })]);
}];
export { render, staticRenderFns };